import { render, staticRenderFns } from "./saleInvoice.vue?vue&type=template&id=17661d6e&"
import script from "./saleInvoice.vue?vue&type=script&lang=js&"
export * from "./saleInvoice.vue?vue&type=script&lang=js&"
import style0 from "./saleInvoice.vue?vue&type=style&index=0&id=17661d6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports